import { createFileRoute, Outlet } from '@tanstack/react-router'

import { requirePlatformScope } from '@/features/auth/require-session'

/**
 * The platform console (ADR 0003): the platform operator's screens, across every org. Anyone
 * else is sent back to the org app (`requirePlatformScope`).
 */
export const Route = createFileRoute('/_app/platform')({
  beforeLoad: ({ context }) => requirePlatformScope(context.queryClient),
  component: Outlet,
})
